import { GraphQLObjectType, GraphQLInt, GraphQLNonNull } from 'graphql'

export interface AuthenticationAttemptRecord {
  readonly requests: number
}

export const AuthenticationAttemptRecordType = new GraphQLObjectType({
  name: 'AuthenticationAttemptRecord',
  fields: () => ({
    requests: {
      description: 'The number of analyzed requests',
      type: new GraphQLNonNull(GraphQLInt)
    }
  })
})
